var _PARTNERS_COLOR_VARIA, _palette;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var COLOR_VARIANTS = /*#__PURE__*/function (COLOR_VARIANTS) {
  COLOR_VARIANTS["MINESHAFT"] = "mineshaft";
  COLOR_VARIANTS["GREYCHATEAU"] = "greyChateau";
  COLOR_VARIANTS["GAINSBORO"] = "gainsboro";
  COLOR_VARIANTS["ALICE"] = "alice";
  COLOR_VARIANTS["GHOSTWHITE"] = "ghostWhite";
  COLOR_VARIANTS["WHITE"] = "white";
  COLOR_VARIANTS["DARKTEAL"] = "darkTeal";
  COLOR_VARIANTS["CORALPRESSED"] = "coralPressed";
  COLOR_VARIANTS["CORAL100"] = "coral100";
  COLOR_VARIANTS["CORAL10"] = "coral10";
  COLOR_VARIANTS["AQUAPRESSED"] = "aquaPressed";
  COLOR_VARIANTS["AQUA100"] = "aqua100";
  COLOR_VARIANTS["AQUA50"] = "aqua50";
  COLOR_VARIANTS["AQUA30"] = "aqua30";
  COLOR_VARIANTS["AQUA10"] = "aqua10";
  COLOR_VARIANTS["FORESTPRESSED"] = "forestPressed";
  COLOR_VARIANTS["FOREST100"] = "forest100";
  COLOR_VARIANTS["FOREST10"] = "forest10";
  COLOR_VARIANTS["CRIMSON100"] = "crimson100";
  COLOR_VARIANTS["CRIMSON5"] = "crimson5";
  COLOR_VARIANTS["BUTTERCUP100"] = "buttercup100";
  COLOR_VARIANTS["BUTTERCUP10"] = "buttercup10";
  COLOR_VARIANTS["VERTICALGRAD"] = "verticalGrad";
  COLOR_VARIANTS["HORIZONTALGRAD"] = "horizontalGrad";
  COLOR_VARIANTS["OVERLAY"] = "overlay";
  COLOR_VARIANTS["OVERLAY60"] = "overlay60";
  COLOR_VARIANTS["QITAF"] = "qitaf";
  COLOR_VARIANTS["MOKAFA"] = "mokafa";
  COLOR_VARIANTS["FURSAN"] = "fursan";
  COLOR_VARIANTS["SHUKRAN"] = "shukran";
  COLOR_VARIANTS["HEADER"] = "header";
  COLOR_VARIANTS["HEADERTEXT"] = "headerText";
  COLOR_VARIANTS["FOOTERSTART"] = "footerStart";
  COLOR_VARIANTS["FOOTEREND"] = "footerEnd";
  COLOR_VARIANTS["SEARCHBAR"] = "searchBar";
  return COLOR_VARIANTS;
}({});
export var PARTNERS_COLOR_VARIANTS = (_PARTNERS_COLOR_VARIA = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_PARTNERS_COLOR_VARIA, COLOR_VARIANTS.CORAL100, {
  main: 'primary',
  dark: 'primaryDark',
  light: 'primaryDark'
}), COLOR_VARIANTS.CORAL10, {
  main: 'primary10',
  contrastText: 'primary'
}), COLOR_VARIANTS.CORALPRESSED, {
  main: 'primaryPressed'
}), COLOR_VARIANTS.AQUA100, {
  main: 'secondary',
  dark: 'secondaryDark',
  light: 'secondaryLight'
}), COLOR_VARIANTS.AQUA50, {
  main: 'secondary50'
}), COLOR_VARIANTS.AQUA30, {
  main: 'secondary30'
}), COLOR_VARIANTS.AQUA10, {
  main: 'secondary10',
  contrastText: 'secondary'
}), COLOR_VARIANTS.AQUAPRESSED, {
  main: 'secondaryPressed'
}), COLOR_VARIANTS.WHITE, {
  contrastText: 'secondary',
  dark: 'secondary10'
}), COLOR_VARIANTS.HEADER, {
  main: 'header'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_PARTNERS_COLOR_VARIA, COLOR_VARIANTS.HEADERTEXT, {
  main: 'headerText'
}), COLOR_VARIANTS.FOOTERSTART, {
  main: 'footerStart'
}), COLOR_VARIANTS.FOOTEREND, {
  main: 'footerEnd'
}), COLOR_VARIANTS.SEARCHBAR, {
  main: 'searchBar'
}));
export var paletteTheme = {
  palette: (_palette = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_palette, COLOR_VARIANTS.MINESHAFT, {
    main: '#333333'
  }), "action", {
    disabledBackground: '#EDF1F3',
    disabled: '#66797F'
  }), COLOR_VARIANTS.GREYCHATEAU, {
    main: '#66797F',
    contrastText: '#fff'
  }), COLOR_VARIANTS.GAINSBORO, {
    main: '#D8DCDE',
    contrastText: '#333333'
  }), COLOR_VARIANTS.ALICE, {
    main: '#EDF1F3'
  }), COLOR_VARIANTS.GHOSTWHITE, {
    main: '#F7F9FA'
  }), COLOR_VARIANTS.WHITE, {
    main: '#FFFFFF',
    contrastText: '#0C9AB0',
    dark: '#E9F6F8'
  }), COLOR_VARIANTS.DARKTEAL, {
    main: '#003143',
    contrastText: '#fff'
  }), COLOR_VARIANTS.CORAL100, {
    main: '#EF4550',
    contrastText: '#fff',
    dark: '#D23241',
    light: '#D23241'
  }), COLOR_VARIANTS.CORALPRESSED, {
    main: '#D23241'
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_palette, COLOR_VARIANTS.CORAL10, {
    main: '#F4E3E4',
    contrastText: '#EF4550'
  }), COLOR_VARIANTS.AQUAPRESSED, {
    main: '#008296'
  }), COLOR_VARIANTS.AQUA100, {
    main: '#0C9AB0',
    contrastText: '#fff',
    dark: '#008296',
    light: '#23A5B9'
  }), COLOR_VARIANTS.AQUA50, {
    main: '#91D2DC'
  }), COLOR_VARIANTS.AQUA30, {
    main: '#BDE4EA'
  }), COLOR_VARIANTS.AQUA10, {
    main: '#E9F6F8',
    contrastText: '#0C9AB0'
  }), COLOR_VARIANTS.FORESTPRESSED, {
    main: '#0A8A11'
  }), COLOR_VARIANTS.FOREST100, {
    main: '#319E37',
    contrastText: '#fff',
    dark: '#0A8A11',
    light: '#0A8A11'
  }), COLOR_VARIANTS.FOREST10, {
    main: '#EAF5EB',
    contrastText: '#319E37'
  }), COLOR_VARIANTS.CRIMSON100, {
    main: '#E11523',
    contrastText: '#fff'
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_palette, COLOR_VARIANTS.CRIMSON5, {
    main: '#FDF3F4',
    contrastText: '#E11523'
  }), COLOR_VARIANTS.BUTTERCUP100, {
    main: '#FFB600',
    contrastText: '#333333'
  }), COLOR_VARIANTS.BUTTERCUP10, {
    main: '#FFF8E6',
    contrastText: '#333333'
  }), COLOR_VARIANTS.OVERLAY, {
    main: 'rgba(0, 0, 0, 0.4)',
    contrastText: '#fff'
  }), COLOR_VARIANTS.OVERLAY60, {
    main: 'rgba(0, 0, 0, 0.6)'
  }), COLOR_VARIANTS.VERTICALGRAD, {
    main: 'linear-gradient(180deg, rgba(0, 0, 0, 7e-05) 0.31%, rgba(0, 0, 0, 0.7) 100%)'
  }), COLOR_VARIANTS.HORIZONTALGRAD, {
    main: 'linear-gradient(270deg, rgba(0, 0, 0, 7e-05) 0.04%, rgba(0, 0, 0, 0.7) 100%)'
  }), COLOR_VARIANTS.QITAF, {
    main: '#4F008C'
  }), COLOR_VARIANTS.MOKAFA, {
    main: '#221AFB'
  }), COLOR_VARIANTS.FURSAN, {
    main: '#211F6E'
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_palette, COLOR_VARIANTS.SHUKRAN, {
    main: '#F0DBB1'
  }), COLOR_VARIANTS.HEADER, {
    main: '#003143'
  }), COLOR_VARIANTS.HEADERTEXT, {
    main: '#FFFFFF'
  }), COLOR_VARIANTS.FOOTERSTART, {
    main: '#003143'
  }), COLOR_VARIANTS.FOOTEREND, {
    main: '#23a5b9'
  }), COLOR_VARIANTS.SEARCHBAR, {
    main: '#003143'
  }))
};